<script setup lang="ts">
import { matchedRouteKey } from 'vue-router';
import { routeViewKey } from '@/utils/routeViewKey';

defineProps({
  is: {
    required: true,
    type: [String, Object], // VNode
  },
});

// The record the enclosing <router-view> renders. Keying on it and its path
// params remounts a page opened for another id (student A -> student B), which
// pages that read the id once at setup need; see routeViewKey.
const route = useRoute();
const matchedRoute = inject(matchedRouteKey, null);
const viewKey = computed(() => routeViewKey(matchedRoute?.value, route.params));
</script>
<template>
    <div class="h-full">
        <component :is="is" :key="viewKey">
        </component>
    </div>
</template>
